<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head dep-head">
            <div class="dep-head__titles">
                <nav class="dep-breadcrumb" aria-label="Breadcrumb">
                    <a class="dep-breadcrumb__link" href="javascript:void(0)">Payments &amp; Deposits</a>
                    <span class="dep-breadcrumb__sep" aria-hidden="true">›</span>
                    <span class="dep-breadcrumb__current">Deposits</span>
                </nav>
                <h1 class="dep-title">Deposit Entry</h1>
            </div>
            <button type="button" class="dep-btn dep-btn--ghost" (click)="openExportModal()">
                <i class="fa fa-download" aria-hidden="true"></i>&nbsp;Export
            </button>
        </div>

        <div class="ppl-container">
            <div class="ppl-content-container">

                <!-- ---------- Summary tiles ---------- -->
                <div class="dep-tiles">
                    <div class="dep-tile">
                        <span class="dep-tile__label">Deposits Entered</span>
                        <span class="dep-tile__value">{{ tileCount }}</span>
                    </div>
                    <div class="dep-tile">
                        <span class="dep-tile__label">Total Deposited</span>
                        <span class="dep-tile__value">{{ tileTotal }}</span>
                    </div>
                    <div class="dep-tile">
                        <span class="dep-tile__label">Applied</span>
                        <span class="dep-tile__value dep-tile__value--pos">{{ tileApplied }}</span>
                    </div>
                    <div class="dep-tile">
                        <span class="dep-tile__label">Unapplied</span>
                        <span class="dep-tile__value dep-tile__value--neg">{{ tileUnapplied }}</span>
                    </div>
                </div>

                <!-- ---------- Add Deposit ---------- -->
                <section class="dep-panel">
                    <div class="dep-panel__head">
                        <span class="dep-tag dep-tag--teal">New</span>
                        <h2 class="dep-panel__title">Add Deposit</h2>
                        <span class="dep-panel__sum">Press Enter in any field to post the deposit</span>
                    </div>
                    <div class="dep-panel__body">
                        <form (submit)="$event.preventDefault(); onAddDeposit()" autocomplete="off">
                            <div class="dep-entry-grid">
                                <div class="dep-field">
                                    <label for="checkNumber">Check Number<span class="dep-req" aria-hidden="true">*</span></label>
                                    <input id="checkNumber" nz-input type="text" placeholder="88410233"
                                        [(ngModel)]="newDeposit.checkNumber" name="checkNumber"
                                        [class.dep-invalid]="addDepositErrors.checkNumber"
                                        [attr.aria-describedby]="'err-checkNumber'" />
                                    <div class="dep-err" id="err-checkNumber" role="alert">{{ addDepositErrors.checkNumber }}</div>
                                </div>

                                <div class="dep-field">
                                    <label for="depositAmount">Deposit Amount<span class="dep-req" aria-hidden="true">*</span></label>
                                    <input id="depositAmount" nz-input type="text" class="dep-amt" placeholder="0.00"
                                        [(ngModel)]="newDeposit.depositAmount" name="depositAmount"
                                        [class.dep-invalid]="addDepositErrors.depositAmount"
                                        [attr.aria-describedby]="'err-depositAmount'" />
                                    <div class="dep-err" id="err-depositAmount" role="alert">{{ addDepositErrors.depositAmount }}</div>
                                </div>

                                <div class="dep-field">
                                    <label for="mcoOrgName">MCO<span class="dep-req" aria-hidden="true">*</span></label>
                                    <ppl-dropdown-select id="mcoOrgName" [(ngModel)]="newDeposit.mcoOrgName" name="mcoOrgName"
                                        [options]="mcoOptions" placeholder="Select MCO…" [appendToBody]="true"
                                        (selectionChange)="onAddDepositMcoChange()">
                                    </ppl-dropdown-select>
                                    <div class="dep-err" id="err-mcoOrgName" role="alert">{{ addDepositErrors.mcoOrgName }}</div>
                                </div>

                                <div class="dep-field">
                                    <label for="bankAccount">Bank Account<span class="dep-req" aria-hidden="true">*</span></label>
                                    <ppl-dropdown-select id="bankAccount" [(ngModel)]="newDeposit.accountNumber" name="bankAccount"
                                        [options]="bankAccountOptionsForAdd" optionLabel="label" optionValue="accountNumber"
                                        placeholder="Select account…" [appendToBody]="true"
                                        (selectionChange)="onAddDepositAccountChange()">
                                    </ppl-dropdown-select>
                                    <div class="dep-err" id="err-bankAccount" role="alert">{{ addDepositErrors.bankAccount }}</div>
                                </div>

                                <div class="dep-field">
                                    <label for="depositDate">Deposit Date<span class="dep-req" aria-hidden="true">*</span></label>
                                    <nz-date-picker id="depositDate" [(ngModel)]="newDeposit.depositDate" name="depositDate"
                                        [nzFormat]="'MM/dd/yyyy'" [nzPlaceHolder]="'Deposit Date'"
                                        [class.dep-invalid]="addDepositErrors.depositDate">
                                    </nz-date-picker>
                                    <div class="dep-err" id="err-depositDate" role="alert">{{ addDepositErrors.depositDate }}</div>
                                </div>
                            </div>

                            <div class="dep-entry-actions">
                                <label nz-checkbox [(ngModel)]="newDeposit.isAdvanceDeposit" name="isAdvanceDeposit">
                                    Is Advance Deposit
                                </label>
                                <button class="dep-btn dep-btn--primary" type="submit" [disabled]="addDepositSubmitting">
                                    {{ addDepositSubmitting ? 'Saving…' : '＋ Add Deposit' }}
                                </button>
                                <button class="dep-btn dep-btn--ghost" type="button" (click)="onClearAddDepositForm()">Clear</button>
                                @if (addDepositApiError) {
                                <span class="dep-err">{{ addDepositApiError }}</span>
                                }
                                @if (addDepositMessage) {
                                <span class="dep-toast">✔ {{ addDepositMessage }}</span>
                                }
                            </div>
                        </form>
                    </div>
                </section>

                <!-- ---------- Deposit list ---------- -->
                <section class="dep-panel">
                    <div class="dep-panel__head">
                        <span class="dep-tag dep-tag--green">Deposits</span>
                        <h2 class="dep-panel__title">All Deposits</h2>
                        <span class="dep-panel__sum">{{ tileCount }} {{ tileCount === 1 ? 'deposit' : 'deposits' }}</span>
                    </div>
                    <div class="dep-panel__body">
                        <div class="dep-filters">
                            <div class="dep-field">
                                <label for="fCheckNumber">Check Number</label>
                                <input id="fCheckNumber" nz-input type="text" placeholder="e.g. 88410233"
                                    [(ngModel)]="filterCheckNumber" name="fCheckNumber"
                                    (keydown.enter)="onFilterSearch()" />
                            </div>
                            <div class="dep-field">
                                <label for="fMco">MCO</label>
                                <ppl-dropdown-select id="fMco" [(ngModel)]="filterMco" name="fMco"
                                    [options]="filterMcoOptions" placeholder="All MCOs"
                                    (selectionChange)="onFilterSearch()">
                                </ppl-dropdown-select>
                            </div>
                            <div class="dep-field">
                                <label for="fAccountNumber">Account Number</label>
                                <p-autoComplete id="fAccountNumber" [(ngModel)]="filterAccountNumber" name="fAccountNumber"
                                    [suggestions]="filteredAccountOptions" (completeMethod)="filterAccountNumberOptions($event)"
                                    placeholder="All accounts"
                                    (onSelect)="onFilterSearch()" (onClear)="onFilterSearch()">
                                </p-autoComplete>
                            </div>
                            <div class="dep-field">
                                <label for="fAdvance">Is Advance Deposit</label>
                                <ppl-dropdown-select id="fAdvance" [(ngModel)]="filterIsAdvanceDeposit" name="fAdvance"
                                    [options]="[{ label: 'Yes', value: 'true' }, { label: 'No', value: 'false' }]"
                                    optionLabel="label" optionValue="value" placeholder="All"
                                    (selectionChange)="onFilterSearch()">
                                </ppl-dropdown-select>
                            </div>
                            <div class="dep-field">
                                <label for="fDepositDateFrom">Deposit Date</label>
                                <nz-date-picker id="fDepositDateFrom" [(ngModel)]="filterDepositDateFrom"
                                    [nzFormat]="'MM/dd/yyyy'" [nzPlaceHolder]="'From'"
                                    (ngModelChange)="onFilterSearch()">
                                </nz-date-picker>
                            </div>
                            <div class="dep-field">
                                <label for="fDepositDateTo">&nbsp;</label>
                                <nz-date-picker id="fDepositDateTo" [(ngModel)]="filterDepositDateTo"
                                    [nzFormat]="'MM/dd/yyyy'" [nzPlaceHolder]="'To'"
                                    (ngModelChange)="onFilterSearch()">
                                </nz-date-picker>
                            </div>
                            <div class="dep-field">
                                <label for="fUtilization">Utilization</label>
                                <ppl-dropdown-select id="fUtilization" [(ngModel)]="filterUtilizationStatus" name="fUtilization"
                                    [options]="utilizationStatusOptions" optionLabel="label" optionValue="value"
                                    placeholder="All" (selectionChange)="onFilterSearch()">
                                </ppl-dropdown-select>
                            </div>
                            <button type="button" class="dep-btn dep-btn--primary" (click)="onFilterSearch()">
                                <i class="fa fa-search" aria-hidden="true"></i>&nbsp;Search
                            </button>
                            <button type="button" class="dep-btn dep-btn--ghost" (click)="onClearFilters()">Clear</button>
                        </div>

                        @if (deposits.length > 0) {
                        <ppl-list-table
                            [data]="deposits"
                            [cols]="cols"
                            [disableSort]="true"
                            [disableSearch]="true"
                            [showCustomSearch]="false"
                            [disableSelection]="true"
                            [gridTitle]="false"
                            [enableActions]="true"
                            [buttonConfig]="manualCashButtonConfig"
                            (gridAction)="onGridAction($event)"
                            [pagination]="true"
                            [rowsToDisplay]="10"
                            [loadPage]="false"
                            [tableScrollable]="true">
                        </ppl-list-table>
                        } @else {
                        <p class="dep-empty">No deposits match the current filters.</p>
                        }
                    </div>
                </section>

            </div>
        </div>
    </div>

    <!-- ---------- Apply Manual Cash modal ---------- -->
    <ppl-popup-dialog [(isVisible)]="showCashModal" [title]="'Apply Manual Cash'" [showClose]="true"
        [showButtons]="true" [showOkButton]="false" [isOkText]="cashApplySubmitting ? 'Applying…' : 'Apply Cash'"
        [okDisabled]="cashApplyDisabled() || cashApplySubmitting" [showButtonIcons]="false" [rightAlignedButtons]="true"
        [styleClass]="'dep-cash-modal'"
        [stickyFooter]="true" size="large" position="top" (cancel)="closeCashModal()" (confirm)="onApplyCash()">
        <div class="dep-modal__body">
            <div class="dep-modal__crumb">
                {{ cashDeposit?.depositId }} · {{ cashDeposit?.depositDateRaw }} · {{ cashDeposit?.bankName }}
            </div>
            <!-- deposit being applied -->
                <div class="dep-kv">
                    <div><span class="dep-kv__k">Check Number</span><span class="dep-kv__v dep-mono">{{ cashDeposit?.checkNumberRaw }}</span></div>
                    <div><span class="dep-kv__k">MCO</span><span class="dep-kv__v">{{ cashDeposit?.mcoOrgNameRaw }}</span></div>
                    <div><span class="dep-kv__k">Deposit Amount</span><span class="dep-kv__v">{{ cashDeposit?.depositAmount }}</span></div>
                    <div><span class="dep-kv__k">Unapplied Balance</span><span class="dep-kv__v">{{ formatCurrency(unappliedBalance()) }}</span></div>
                </div>

                <!-- claim lookup -->
                <div class="dep-sublabel">Add Claim</div>
                <form nz-form [formGroup]="cashIcnForm" (ngSubmit)="onAddCashClaim()" autocomplete="off">
                    <div class="dep-icn-row">
                        <div class="dep-field">
                            <label for="icn">PPL ICN</label>
                            <input id="icn" nz-input type="text" class="dep-mono-input" maxlength="20"
                                placeholder="NY1093827100" formControlName="icn"
                                [class.dep-invalid]="cashIcnError" (input)="cashIcnError = ''" />
                        </div>
                        <button class="dep-btn dep-btn--ghost" type="submit" [disabled]="cashLookupLoading">
                            {{ cashLookupLoading ? 'Looking up…' : '＋ Add Claim' }}
                        </button>
                        <span class="dep-hint">Press Enter to look up the claim and add it below</span>
                    </div>
                    <div class="dep-err" role="alert">{{ cashIcnError }}</div>
                </form>

                <!-- claims being paid -->
                <div class="dep-tbl-scroll">
                    <table>
                        <thead>
                            <tr>
                                <th>PPL ICN</th>
                                <th>Consumer</th>
                                <th>Service Date</th>
                                <th class="dep-num">Claim Amount</th>
                                <th class="dep-num">Paid</th>
                                <th class="dep-num">Outstanding</th>
                                <th class="dep-num">Payment Amount</th>
                                <th>CARC</th>
                                <th>RARC</th>
                                <th class="dep-ctr"></th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (c of cashClaims; track c.icn) {
                            <tr>
                                <td class="dep-mono">{{ c.icn }}</td>
                                <td>{{ c.consumer }}</td>
                                <td>{{ c.serviceDate }}</td>
                                <td class="dep-num">{{ formatCurrency(c.claimAmount) }}</td>
                                <td class="dep-num">{{ formatCurrency(c.paid) }}</td>
                                <td class="dep-num">{{ formatCurrency(c.outstanding) }}</td>
                                <td class="dep-num">
                                    <input class="dep-pay-input" [class.dep-invalid]="isPaymentOver(c)"
                                        type="text" inputmode="decimal"
                                        [value]="c.payment.toFixed(2)"
                                        [attr.aria-label]="'Payment amount for ' + c.icn"
                                        (change)="onPaymentChange(c, $any($event.target).value)" />
                                </td>
                                <td>
                                    <input class="dep-pay-input" type="text" [(ngModel)]="c.carc"
                                        name="carc-{{ c.icn }}" placeholder="Optional"
                                        [attr.aria-label]="'CARC for ' + c.icn"
                                        (change)="onCarcRarcChange()" />
                                </td>
                                <td>
                                    <input class="dep-pay-input" type="text" [(ngModel)]="c.rarc"
                                        name="rarc-{{ c.icn }}" placeholder="Optional"
                                        [attr.aria-label]="'RARC for ' + c.icn"
                                        (change)="onCarcRarcChange()" />
                                </td>
                                <td class="dep-ctr">
                                    <button class="dep-row-x" type="button" (click)="removeCashClaim(c.icn)"
                                        [attr.aria-label]="'Remove ' + c.icn">✕</button>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
                @if (!cashClaims.length) {
                <p class="dep-empty">No claims added yet. Enter a PPL ICN above.</p>
                }

                <!-- running totals -->
                <div class="dep-apply-summary">
                    <div><span class="dep-kv__k">Claims</span><span class="dep-kv__v">{{ cashClaims.length }}</span></div>
                    <div><span class="dep-kv__k">Total Payment</span><span class="dep-kv__v">{{ formatCurrency(totalPayment()) }}</span></div>
                    <div><span class="dep-kv__k">Remaining on Deposit</span>
                        <span class="dep-kv__v" [class.dep-apply-summary__v--over]="remainingOnDeposit() < 0">{{ formatCurrency(remainingOnDeposit()) }}</span>
                    </div>
                </div>
                <div class="dep-err" role="alert">{{ cashApplyError }}</div>
            </div>
    </ppl-popup-dialog>

    <!-- ---------- Export modal ---------- -->
    <ppl-popup-dialog [(isVisible)]="showExportModal" [title]="'Export Deposits'" [showClose]="true"
        [showButtons]="true" [showOkButton]="false" [isOkText]="exportSubmitting ? 'Exporting…' : 'Export'"
        [okDisabled]="exportSubmitDisabled() || exportSubmitting" [showButtonIcons]="false" [rightAlignedButtons]="true"
        size="medium" position="top" (cancel)="closeExportModal()" (confirm)="onExportSubmit()">
        <div class="dep-export-grid">
            <div class="dep-field">
                <label for="exportTimeframe">Timeframe</label>
                <ppl-dropdown-select id="exportTimeframe" [(ngModel)]="exportTimeframe"
                    [options]="exportTimeframeOptions" optionLabel="label" optionValue="value"
                    [showClearButton]="false" (selectionChange)="onExportTimeframeChange()">
                </ppl-dropdown-select>
            </div>
            <div class="dep-field">
                <label for="exportStartDate">Start Date<span class="dep-req" aria-hidden="true">*</span></label>
                <nz-date-picker id="exportStartDate" [(ngModel)]="exportStartDate" [nzFormat]="'MM/dd/yyyy'"
                    [nzPlaceHolder]="'Start Date'">
                </nz-date-picker>
            </div>
            <div class="dep-field">
                <label for="exportEndDate">End Date<span class="dep-req" aria-hidden="true">*</span></label>
                <nz-date-picker id="exportEndDate" [(ngModel)]="exportEndDate" [nzFormat]="'MM/dd/yyyy'"
                    [nzPlaceHolder]="'End Date'">
                </nz-date-picker>
            </div>
            <div class="dep-field">
                <label for="exportReportType">Report Type</label>
                <ppl-dropdown-select id="exportReportType" [(ngModel)]="exportReportType"
                    [options]="exportReportTypeOptions" optionLabel="label" optionValue="value"
                    placeholder="All Deposits" [showClearButton]="false">
                </ppl-dropdown-select>
            </div>
        </div>
        <div class="dep-err" role="alert">{{ exportError }}</div>
    </ppl-popup-dialog>
</ng-container>
